import { render, staticRenderFns } from "./burger.vue?vue&type=template&id=d872cd42&scoped=true"
import script from "./burger.vue?vue&type=script&lang=js"
export * from "./burger.vue?vue&type=script&lang=js"
import style0 from "./burger.vue?vue&type=style&index=0&id=d872cd42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d872cd42",
  null
  
)

export default component.exports